<template>
    <v-container fluid>
        <v-row v-if="showPdfPreview">
            <div
                style="
                    display: show;
                    z-index: 9999999;
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    background-color: rgba(255, 255, 255, 0.074);
                    width: 100%;
                    height: 100vw;
                "
            >
                <div style="margin-top: 20px; margin-bottom: 40px; width: 40%; height: 100vh; margin: 0 auto">
                    <v-btn
                        style="float: right; margin-top: 50px; margin-bottom: 10px"
                        depressed
                        @click="closePDFpreview()"
                        icon
                    >
                        <v-icon large>fas fa-window-close</v-icon>
                    </v-btn>
                    <iframe
                        id="pdf-preview-div"
                        style="width: 100%; margin-bottom: 20px; height: 87vh; display: block"
                        :src="pdfLink"
                    >
                        <p>Your browser does not support iframes.</p>
                    </iframe>
                </div>
            </div>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="invoicesTable.additionalFilters"
                                    :default-sort="invoicesTable.defaultSort"
                                    :excel="true"
                                    :fields="invoicesTable.headers"
                                    :header-selection-key="'invoices-headers'"
                                    :height="invoicesTable.height"
                                    :total-records="invoicesTable.total"
                                    :filter-save-key="'invoices-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in invoicesTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td v-if="item.cancelled == false && item.cancels == null">
                                            <v-btn
                                                v-if="item.paid"
                                                x-small
                                                color="#00800040"
                                                fab
                                                depressed
                                                @click="togglePaid(key)"
                                            >
                                                <v-icon x-small color="#008000">fas fa-check</v-icon></v-btn
                                            >
                                            <v-btn
                                                v-if="!item.paid"
                                                x-small
                                                color="#6F6F6F40"
                                                fab
                                                depressed
                                                @click="togglePaid(key)"
                                            >
                                                <v-icon x-small color="#6F6F6F">fas fa-question</v-icon></v-btn
                                            >
                                        </td>
                                        <td v-else>
                                            <v-tooltip bottom v-if="item.cancelled == true">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="text-uppercase font-weight-bold"
                                                        text-color="#ff0000"
                                                        color="#ffffff"
                                                        >S</v-chip
                                                    >
                                                </template>
                                                <span>{{ item.cancelled_by_number }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="item.cancels != null">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-chip
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        class="text-uppercase font-weight-bold"
                                                        text-color="#ff0000"
                                                        color="#ffffff"
                                                        >S</v-chip
                                                    >
                                                </template>
                                                <span>{{ item.cancels_number }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="invoicesTable.selectedHeaders.includes('number')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.number }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="invoicesTable.selectedHeaders.includes('invoice_sequence_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.invoice_sequence_display }}
                                        </td>
                                        <td
                                            v-if="
                                                invoicesTable.selectedHeaders.includes(
                                                    'internal_office_bank_account_id',
                                                )
                                            "
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.internal_office_bank_account_display }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="invoicesTable.selectedHeaders.includes('entity_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.entity_display }}
                                        </td>
                                        <td
                                            v-if="invoicesTable.selectedHeaders.includes('date_of_issue')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.date_of_issue_display }}
                                        </td>
                                        <td
                                            v-if="invoicesTable.selectedHeaders.includes('due_date')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.due_date_display }}
                                        </td>
                                        <td
                                            class="text-right font-weight-bold"
                                            v-if="invoicesTable.selectedHeaders.includes('amount_with_tax')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.amount_with_tax_display }}
                                        </td>
                                        <td
                                            class="text-right"
                                            v-if="invoicesTable.selectedHeaders.includes('amount_without_tax')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.amount_without_tax_display }}
                                        </td>
                                        <td
                                            v-if="invoicesTable.selectedHeaders.includes('billing_list_id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.billing_list_display }}
                                        </td>

                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="
                                                            getPDF(
                                                                item.id,
                                                                item.gdpr_edit_lock,
                                                                item.gdpr_invoice_file_id
                                                                    ? item.gdpr_invoice_file_id.link
                                                                    : null,
                                                            )
                                                        "
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-file-pdf</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.pdf') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn icon v-bind="attrs" @click="getZip(item.id)" v-on="on">
                                                        <v-icon small>fa-file-archive</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.zip') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Invoices',
    components: {TheTable},
    data: function () {
        return {
            showPdfPreview: false,
            pdfSource: '',
            invoicesTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.paid'), value: 'paid', type: '', allowFilter: false},
                    {text: this.$t('fields.number'), value: 'number', type: '', allowFilter: true},
                    {text: this.$t('fields.sequence'), value: 'invoice_sequence_id', type: '', allowFilter: true},
                    {
                        text: this.$t('fields.officeAccount'),
                        value: 'internal_office_bank_account_id',
                        type: 'multiple|internal-office-bank-accounts',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.client'), value: 'entity_id', type: 'multiple|entities', allowFilter: true},
                    {text: this.$t('fields.invoiceDate'), value: 'date_of_issue', type: '', allowFilter: true},
                    {text: this.$t('fields.dueDate'), value: 'due_date', type: '', allowFilter: true},
                    {
                        text: this.$t('fields.totalAmountGross'),
                        value: 'amount_without_tax',
                        type: '',
                        allowFilter: true,
                    },
                    {text: this.$t('fields.totalAmountNet'), value: 'amount_with_tax', type: '', allowFilter: true},
                    {
                        text: this.$t('fields.billingList'),
                        value: 'billing_list_id',
                        type: 'multiple|billing-lists',
                        allowFilter: true,
                    },

                    {text: this.$t('fields.file'), value: 'file', type: '', allowFilter: false, sortable: false},
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [
                    {text: this.$t('fields.number'), value: 'number', type: 'string'},
                    {
                        text: this.$t('fields.sequence'),
                        value: 'invoice_sequence_id',
                        type: 'dropdown|invoice-sequences',
                    },
                    {
                        text: this.$t('fields.officeAccount'),
                        value: 'internal_office_bank_account_id',
                        type: 'dropdown|internal-office-bank-accounts',
                    },
                    {text: this.$t('fields.client'), value: 'entity_id', type: 'dropdown|entities'},
                    {text: this.$t('fields.invoiceDate'), value: 'date_of_issue', type: 'date_range'},
                    {text: this.$t('fields.dueDate'), value: 'due_Date', type: 'date_range'},
                    {text: this.$t('fields.totalAmountGross'), value: 'amount_without_tax', type: 'price_range'},
                    {text: this.$t('fields.totalAmountNet'), value: 'amount_with_tax', type: 'price_range'},
                    {text: this.$t('fields.billingList'), value: 'billing_list_id', type: 'dropdown|billing-lists'},
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'number',
                    descending: true,
                },
            },
        };
    },
    methods: {
        closePDFpreview() {
            this.showPdfPreview = false;
            this.pdfLink = '';
        },
        addClick() {
            this.$router.push('/invoices/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/invoices/' + id);
            } else {
                let routeData = this.$router.resolve('/invoices/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.invoicesTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'invoices', request, (data, success) => {
                if (success) {
                    vm.invoicesTable.items = data.items;
                    vm.invoicesTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        getPDF(id, gdpr_edit_lock, link) {
            let vm = this;
            if (gdpr_edit_lock) {
                if (link) {
                    vm.showPdfPreview = true;
                    vm.pdfLink = link;
                } else {
                    vm.$alert(vm.$t('alerts.invoiceFileLinkNotFound'));
                }
            } else {
                this.$APICall(
                    'get',
                    'invoices/pdf/' + id,
                    {},
                    (data, success) => {
                        if (success) {
                            vm.showPdfPreview = true;
                            vm.pdfLink = data.link;
                            // window.open(data.link);
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    },
                    true,
                );
            }
        },
        getZip(id) {
            let vm = this;
            this.$APICall(
                'get',
                'invoices/zip/' + id,
                {},
                (data, success) => {
                    if (success) {
                        if (data.message == 1) {
                            vm.$alert(vm.$t('alerts.noFilesToAttachToInvoice'));
                        } else {
                            window.open(data.link);
                        }
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                true,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'invoices',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/invoices', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.invoicesTable.height = window.innerHeight - 310 + 'px';
        },
        togglePaid(itemIdx) {
            let invoice = this.invoicesTable.items[itemIdx];
            this.invoicesTable.items[itemIdx].paid = !invoice.paid;
            this.$APICall('post', 'invoices/paid/' + invoice.id, {}, () => {}, false);
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.invoices'), href: '/#/invoices', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
